import { Helmet } from 'react-helmet-async';
import React from 'react';
import PermissionsFormContainer from '../../../../containers/organizations/PermissionsFormContainer.jsx';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

const EditPermissions = ({ userId, projectId, slug }) => (
  <>
    <Helmet>
      <title>Permissions | ChangeSync</title>
    </Helmet>

    <PermissionsFormContainer userId={userId} projectId={projectId} />
  </>
);

EditPermissions.getInitialProps = ({ query }) => ({
  slug: query.slug,
  userId: Number(query.userId),
  projectId: Number(query.projectId),
});

export default requireAuth(withRouterParams(EditPermissions));
